import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './_header.css'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'

export class YearInReviewHeader extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool,
    mobileNav: PropTypes.bool,
    onFacebookShare: PropTypes.func,
    onTwitterShare: PropTypes.func,
    site: PropTypes.object,
    toggleMobileNav: PropTypes.func,
    year: PropTypes.string,
  }

  state = {
    progress: 0,
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll () {
    const windowHeight = window.innerHeight
    const windowPosition = window.pageYOffset
    const documentHeight = document.body.scrollHeight
    const percentage = windowPosition / (documentHeight - windowHeight) * 100

    this.setState({
      progress: percentage,
    })
  }

  render () {
    const {
      isLoggedIn,
      toggleMobileNav,
      mobileNav,
      year,
      onTwitterShare,
      onFacebookShare,
    } = this.props
    const {
      progress,
    } = this.state

    return (
      <div className={styles.headerWrapper}>
        <div className={`${styles.header} ${mobileNav ? styles.active : ''}`}>
          <button className={styles.headerNavToggle} onClick={toggleMobileNav}>
            {mobileNav
              ? <Svg name='close-icon' width={16} height={16} fill='white' />
              : <Svg name='hamburger-icon' width={16} height={16} fill='white' />
            }
          </button>
          <div className={styles.headerLogo}>
            <a href={isLoggedIn ? '/my_home/' : '/'}>
              <svg>
                <use xlinkHref='#mmf-logo' fill="white" />
              </svg>
            </a>
          </div>
          <h2 className={styles.headerTagline}>
            <FormattedMessage
              id='yearInReview.2017.header.tagline'
              defaultMessage='See Your Year In Review'
            />
          </h2>
          <div className={styles.headerLinks}>
            { !isLoggedIn ?
              <ul className={styles.authLinks}>
                <li>
                  <a href={`/auth/login?next=%2Fyear-in-review%2F${year}`}>
                    <FormattedMessage id='site.nav.login' defaultMessage='Log in' />
                  </a>
                </li>
                <li className={styles.accent}>
                  <a href={`/auth/signup?next=%2Fyear-in-review%2F${year}`}>
                    <FormattedMessage id='site.nav.signup' defaultMessage='Sign Up' />
                  </a>
                </li>
              </ul> :
                <ul className={styles.authLinks}>
                  <li>
                    <a href='/auth/logout'>
                      <FormattedMessage id='site.nav.logout' defaultMessage='Logout' />
                    </a>
                  </li>
                </ul>
            }
            <ul className={styles.socialLinks}>
              <li onClick={onFacebookShare}>
                <Svg name='facebook' width={16} height={16} fill='white' />
              </li>
              <li onClick={onTwitterShare}>
                <Svg name='twitter' width={16} height={16} fill='white' />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.progress} style={ { 'width': `${progress}%` } } />
      </div>
    )
  }
}

YearInReviewHeader.propTypes = {
}

export default YearInReviewHeader



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Header/Header.jsx